import { regionTitle } from 'shared-pages/common/constants';

export interface PivotDimensionDef {
  id: string;
  label: string;
  valueType: 'string' | 'number' | 'date';
  hidden?: boolean; // Hide from display suggestions but allow in filters
}

export interface PivotMeasureDef {
  id: string;
  label: string;
}

export interface PivotPresetDef {
  id: string;
  label: string;
  rows: string[];
  cols: string[];
}

export interface PivotCatalogDef {
  name: string;
  dimensions: PivotDimensionDef[];
  measures: PivotMeasureDef[];
  presets: PivotPresetDef[];
}

// Collections table catalog - IDs must match backend adapter exactly
const collectionsCatalog: PivotCatalogDef = {
  name: 'Collections',
  dimensions: [
    // Core dimensions supported by the backend adapter

    // { id: 'isActiveLabel', label: 'Ενεργή', valueType: 'string' },
    { id: 'regionName', label: regionTitle, valueType: 'string' },
    // { id: 'routeLineId', label: 'Διαδρομή', valueType: 'number' },
    // { id: 'collectionOrderCode', label: 'Αίτηση Συλλογής', valueType: 'string' },
    { id: 'year', label: 'Έτος Συλλογής', valueType: 'date' },
    { id: 'month', label: 'Έτος-Μήνας Συλλογής', valueType: 'date' },
    // Additional dimensions for field bundles (expose all supported dims)
    { id: 'dateCollected', label: 'Ημερομηνία Συλλογής', valueType: 'date' },
    // { id: 'collectorId', label: 'ID Συλλέκτη', valueType: 'number', hidden: true }, // Hidden from display
    { id: 'collectorName', label: 'Συλλέκτης', valueType: 'string' }, // For display
    { id: 'wastereceptionpoint', label: 'Παραλαβή Αποβλήτων', valueType: 'string' },
    // { id: 'vehicleId', label: 'ID Οχήματος', valueType: 'number', hidden: true }, // Hidden from display
    { id: 'vehiclePlate', label: 'Πινακίδα Οχήματος', valueType: 'string' }, // For display (plate number)
    // { id: 'vehicleBrand', label: 'Μάρκα', valueType: 'string' }, // Optional secondary label
    // { id: 'driverId', label: 'ID Οδηγού', valueType: 'number', hidden: true }, // Hidden from display
    { id: 'driverName', label: 'Οδηγός Συλλέκτη', valueType: 'string' }, // For display
    { id: 'collectionPointName', label: 'Όνομα Σημείου Συλλογής', valueType: 'string' },
    { id: 'materialName', label: 'Απόβλητο', valueType: 'string' },
    { id: 'cpGroup', label: 'Κατηγορία Σημείου Συλλογής', valueType: 'string' },
    { id: 'profession', label: 'Επάγγελμα Σημείου Συλλογής', valueType: 'string' },
  ],
  measures: [
    // Collection and line-level measures
    { id: 'sum_netWeight', label: 'Άθροισμα Βάρους' },
    { id: 'count_collections', label: 'Πλήθος Συλλογών' },
    { id: 'avg_netWeight', label: 'Μέσο Βάρος' },
    //{ id: 'count_lines', label: 'Σύνολο Γραμμών' },
    //{ id: 'avg_netWeight', label: 'Μέσο Καθαρό Βάρος' },
    //{ id: 'sum_grossWeight', label: 'Άθροισμα Μικτού Βάρους' },
    //{ id: 'avg_grossWeight', label: 'Μέσο Μικτό Βάρος' },
  ],
  presets: [
    {
      id: 'monthly-by-region',
      label: 'Μηνιαίες Συλλογές ανά Συλλέκτη',
      rows: ['collectorName'],
      cols: ['month'],
    },
    {
      id: 'monthly-by-material',
      label: 'Μηνιαίες Συλλογές ανά Απόβλητο',
      rows: ['materialName'],
      cols: ['month'],
    },
    {
      id: 'material-by-collector',
      label: 'Συλλογές Αποβλήτων ανά Συλλέκτη',
      rows: ['collectorName'],
      cols: ['materialName'],
    },
    {
      id: 'yearly-by-material-by-collector',
      label: 'Ετήσιες Συλλογές Αποβλήτων ανά Συλλέκτη',
      rows: ['collectorName', 'materialName'],
      cols: ['year'],
    },
    {
      id: 'monthly-by-material-by-collector',
      label: 'Μηνιαίες Συλλογές Αποβλήτων ανά Συλλέκτη',
      rows: ['collectorName', 'materialName'],
      cols: ['month'],
    },
    // // Monthly Analysis
    // {
    //   id: 'monthly-by-region',
    //   label: 'Μηνιαία ανά Περιοχή',
    //   rows: ['regionName'],
    //   cols: ['month'],
    // },
    // {
    //   id: 'active-by-month',
    //   label: 'Ενεργή ανά Μήνα',
    //   rows: ['isActiveLabel'],
    //   cols: ['month'],
    // },
    // {
    //   id: 'routeline-by-month',
    //   label: 'Διαδρομή ανά Μήνα',
    //   rows: ['routeLineId'],
    //   cols: ['month'],
    // },

    // // Regional Analysis
    // {
    //   id: 'region-totals',
    //   label: 'Σύνολα ανά Περιοχή',
    //   rows: ['regionName'],
    //   cols: [],
    // },
    // {
    //   id: 'region-by-active',
    //   label: 'Περιοχή ανά Ενεργές',
    //   rows: ['regionName'],
    //   cols: ['isActiveLabel'],
    // },

    // // Route Analysis
    // {
    //   id: 'routeline-totals',
    //   label: 'Σύνολα Διαδρομής',
    //   rows: ['routeLineId'],
    //   cols: [],
    // },
    // {
    //   id: 'routeline-by-active',
    //   label: 'Διαδρομή ανά Ενεργές',
    //   rows: ['routeLineId'],
    //   cols: ['isActiveLabel'],
    // },

    // // Status Analysis
    // {
    //   id: 'active-status-overview',
    //   label: 'Επισκόπηση Ενεργές',
    //   rows: ['isActiveLabel'],
    //   cols: [],
    // },

    // // Cross Analysis
    // {
    //   id: 'region-vs-routeline',
    //   label: 'Περιοχή vs Διαδρομή',
    //   rows: ['regionName'],
    //   cols: ['routeLineId'],
    // },

    // // Material Analysis
    // {
    //   id: 'material-overview',
    //   label: 'Επισκόπηση Υλικών',
    //   rows: ['materialName'],
    //   cols: [],
    // },
    // {
    //   id: 'material-by-region',
    //   label: 'Υλικά ανά Περιοχή',
    //   rows: ['materialName'],
    //   cols: ['regionName'],
    // },

    // // Vehicle Analysis
    // {
    //   id: 'vehicle-overview',
    //   label: 'Επισκόπηση Οχημάτων',
    //   rows: ['vehiclePlate'],
    //   cols: [],
    // },
    // {
    //   id: 'vehicle-by-region',
    //   label: 'Οχήματα ανά Περιοχή',
    //   rows: ['vehiclePlate'],
    //   cols: ['regionName'],
    // },

    // // Driver Analysis
    // {
    //   id: 'driver-overview',
    //   label: 'Επισκόπηση Οδηγών',
    //   rows: ['driverName'],
    //   cols: [],
    // },
    // {
    //   id: 'driver-by-vehicle',
    //   label: 'Οδηγοί ανά Όχημα',
    //   rows: ['driverName'],
    //   cols: ['vehiclePlate'],
    // },
  ],
};

// Future catalogs for other entities
const materialsCatalog: PivotCatalogDef = {
  name: 'Materials',
  dimensions: [
    { id: 'code', label: 'Material Code', valueType: 'string' },
    { id: 'name', label: 'Material Name', valueType: 'string' },
    { id: 'isActive', label: 'Active Status', valueType: 'string' },
    { id: 'materialTypeId', label: 'Material Type', valueType: 'number' },
  ],
  measures: [{ id: 'count', label: 'Count' }],
  presets: [{ id: 'type-overview', label: 'Ανά Τύπο', rows: ['materialTypeId'], cols: [] }],
};

const driversCatalog: PivotCatalogDef = {
  name: 'Drivers',
  dimensions: [
    { id: 'firstName', label: 'First Name', valueType: 'string' },
    { id: 'lastName', label: 'Last Name', valueType: 'string' },
    { id: 'isActive', label: 'Active Status', valueType: 'string' },
    { id: 'licenseType', label: 'License Type', valueType: 'string' },
  ],
  measures: [
    { id: 'count', label: 'Count' },
    { id: 'count_collections', label: 'Collection Count' },
  ],
  presets: [
    { id: 'status-overview', label: 'Επισκόπηση Ενεργών', rows: ['isActive'], cols: [] },
    { id: 'license-analysis', label: 'Ανάλυση Τύπου Άδειας', rows: ['licenseType'], cols: [] },
  ],
};

// Catalog registry
const catalogs: Record<string, PivotCatalogDef> = {
  collections: collectionsCatalog,
  materials: materialsCatalog,
  drivers: driversCatalog,
};

export const pivotCatalog = {
  collections: collectionsCatalog,
  materials: materialsCatalog,
  drivers: driversCatalog,
};

export function getPivotCatalog(tableId: string): PivotCatalogDef {
  const catalog = catalogs[tableId];
  if (!catalog) {
    throw new Error(
      `No pivot catalog found for table: ${tableId}. Available tables: ${Object.keys(catalogs).join(
        ', ',
      )}`,
    );
  }
  return catalog;
}

export function getAvailableTableIds(): string[] {
  return Object.keys(catalogs);
}

// Helper function to get dimension by ID across all tables
export function getDimensionById(tableId: string, dimId: string): PivotDimensionDef | undefined {
  const catalog = catalogs[tableId];
  return catalog?.dimensions.find((d) => d.id === dimId);
}

// Helper function to get displayable dimensions (excludes hidden ones)
export function getDisplayableDimensions(tableId: string): PivotDimensionDef[] {
  const catalog = catalogs[tableId];
  return catalog?.dimensions.filter((d) => !d.hidden) || [];
}

// Helper function to get measure by ID across all tables
export function getMeasureById(tableId: string, measureId: string): PivotMeasureDef | undefined {
  const catalog = catalogs[tableId];
  return catalog?.measures.find((m) => m.id === measureId);
}
